import { createRouter, createWebHistory } from 'vue-router'
import Room from '@/views/Room.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      redirect: '/room'
    },
    {
      path: '/room/:id',
      name: 'room',
      component: Room
    },
    {
      path: '/room',
      name: 'create-room',
      component: Room
    }
  ]
})

export default router
